import { render, staticRenderFns } from "./NewFacadeModal.vue?vue&type=template&id=3a600852&lang=pug&"
import script from "./NewFacadeModal.vue?vue&type=script&lang=js&"
export * from "./NewFacadeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports